export default function description() {
    return (
        <div className="card__description-basic">
            <div className="card__description">
                <p className="card__description-text">
                    Гібрид соняшнику НС Таурус відноситься до групи середньоранніх гібридів - період його вегетації займає від 109 до 113 днів. Рослини мають середньопотужну розгалужену кореневу систему, стебла заввишки від 160 до 170 см і тонкий опуклий кошик діаметром від 20 до 23 см. Потенційна врожайність даного гібриду становить 55 ц/га. НС Таурус – це соняшник під «Євролайтінг», який дає змогу добиватися високих урожаїв навіть у посушливі роки. Він стійкий до захворювань листя та стебла, а також чудово почувається в різних кліматичних умовах.
                </p>
                <p className="card__description-title">
                    Характеристики
                </p>
                <table className="card__description__table">
                    <tr>
                        <td className="card__description__td">Генетичний потенціал врожайності</td>
                        <td className="card__description__th-index">57 ц/га</td>
                    </tr>
                    <tr>
                        <td className="card__description__td">Група стиглості</td>
                        <td className="card__description__th-index">109-113 днів</td>
                    </tr>
                    <tr>
                        <td className="card__description__td card__description__td--link">Тип</td>
                        <td className="card__description__th-index">Помірно інтенсивний</td>
                    </tr>
                    <tr>
                        <td className="card__description__td card__description__td--link">Висота рослини</td>
                        <td className="card__description__th-index">160-170 см</td>
                    </tr>
                    <tr>
                        <td className="card__description__td">Олійність</td>
                        <td className="card__description__th-index">51-52%</td>
                    </tr>
                    <tr>
                        <td className="card__description__td">Рекомендовані зони вирощування</td>
                        <td className="card__description__th-index">Степ, Лісостеп, Полісся</td>
                    </tr>
                    <tr>
                        <td className="card__description__td card__description__td--link">Стійкість до вовчка</td>
                        <td className="card__description__th-index">A-E</td>
                    </tr>
                </table>
                <p className="card__description-title">
                    Короткі дані
                </p>
                <ol className="card__description-list">
                    <li className="card__description-numbering">Енергія початкового росту: 9/10</li>
                    <li className="card__description-numbering">Посухостійкість: 9/10</li>
                    <li className="card__description-numbering">Стійкість до вилягання: 8/10</li>
                    <li className="card__description-numbering">Толерантність до фомопсису: 10/10</li>
                    <li className="card__description-numbering">Толерантність до іржі: 9/10</li>
                </ol>
                <div className="card__description-title">Врожайність</div>
                <ol className="card__description-list">
                    <li className="card__description-numbering">Черкаська область, Звенигородський район: 41 ц/га</li>
                    <li className="card__description-numbering">Полтавська область, Кременчуцький район: 36 ц/га</li>
                    <li className="card__description-numbering">Кіровоградська область, Новомиргородський район: 36 ц/га</li>
                    <li className="card__description-numbering">Миколаївська область, Арбузинський район: 33 ц/га</li>
                    <li className="card__description-numbering">Одеська область, Татарбунарський район: 24 ц/га</li>
                </ol>
            </div>
            <div className="card__description-preference">
                <div className="aside__title--new">Головні переваги</div>
                <div className="asede__head">
                    <div className="aside__block">Високий потенція урожайності</div>
                    <div className="aside__block">Найкращу віддачу забезпечує на родючих грунтах</div>
                    <div className="aside__block">Один із найбільш високоврожайних гібридів з високим вмістом олії</div>
                </div>
            </div>
        </div>
    );
}
